((ProductPornstar, $) => {
  'use strict';

  let $form;
  let $orificeContainer;
  let $orificeSelect;
  let $orificeImage;
  let $textureSelect;
  let $playButton;
  let $videoContainer;
  let $video;
  let $addToCart;
  let $texture;
  let $textureTitle;
  let $orificeTitle;
  let $videoClose;
  let $orificeBest;
  let $textureBest;
  let $purchaseBarVariant;
  let $description;

  const cacheDom = () => {
    $form = $('.js-product-selection-form');
    $orificeContainer = $form.find('.js-orifice-container');
    $orificeSelect = $form.find('.js-orifice-select');
    $orificeImage = $('.js-orifice-image');
    $textureSelect = $form.find('.js-texture-select');
    $playButton = $('.js-pornstar-play-button');
    $videoContainer = $('.js-pornstar-video-container');
    $video = $('.js-product-pornstar-video');
    $addToCart = $('.js-pornstar-button');
    $texture = $('.js-texture-image');
    $textureTitle = $('.js-texture-title');
    $orificeTitle = $form.find('.js-orifice-title');
    $videoClose = $('.js-pornstar-video-close');
    $orificeBest = $('.js-product-high-seller');
    $textureBest = $('.js-texture-best-seller');
    $purchaseBarVariant = $('.js-purchase-bar-variant');
    $description = $('.js-description');
  };

  const setActiveState = ($this, activeClass) => {
    if (!$this.hasClass(activeClass)) {
      $this.siblings(`.${activeClass}`).removeClass(activeClass);
      $this.addClass(activeClass);
    }
  };

  const setActiveDescription = function (index) {
    if (parseInt(index) <= $description.length) {
      $description.each(function (i) {
        if (i + 1 === parseInt(index)) {
          $description.removeClass('active');
          if ($(this).text().trim().length > 0) {
            $(this).addClass('active');
          } else {
            $description.first().addClass('active');
          }
        }
      });
    } else {
      $description.removeClass('active');
      $description.first().addClass('active');
    }
  };

  const bindUIActions = () => {
    $orificeSelect.on('click', function selectOrifice() {
      const $this = $(this);
      const showingClass = 'showing';
      const orificeActive = 'active';
      const orifice = $this.attr('data-orifice');
      const orificeContainerClass = 'active-orifice-container';

      let $image;
      let $container;
      let imageSet = false;
      let containerSet = false;
      let $firstVariantInContainer;
      let textureSet = false;
      let firstOrifice = false;

      setActiveState($this, 'product-orifice-side-view--active');

      $orificeTitle.text(orifice);

      $orificeImage.each(function setOrificeImage(index) {
        if ($(this).attr('data-orifice') === orifice && !imageSet) {
          if (index === 0) {
            firstOrifice = true;
          }
          $image = $(this);
          imageSet = true;
        }
      });

      if (firstOrifice) {
        $orificeBest.show();
        $textureBest.show();
      } else {
        $orificeBest.hide();
        $textureBest.hide();
      }

      $orificeImage.removeClass(orificeActive);
      $image.addClass(orificeActive);

      if ($video.length) {
        $video[0].pause();
        $videoContainer.removeClass(showingClass);
        $playButton.fadeIn();
      }

      $orificeContainer.each(function showContainer() {
        if ($(this).attr('data-orifice') === orifice && !containerSet) {
          $container = $(this);
          $firstVariantInContainer = $container.find('.js-texture-select').first();
          containerSet = true;
        }
      });
      $orificeContainer.removeClass(orificeContainerClass);
      $container.addClass(orificeContainerClass);

      $textureTitle.text($firstVariantInContainer.attr('data-variant-name-actual'));

      setActiveState($firstVariantInContainer, 'product-texture-side-view--active');
      setActiveDescription($firstVariantInContainer.attr('data-index'));
      $addToCart.attr('data-variant-id', $firstVariantInContainer.attr('data-variant-id'));
      $purchaseBarVariant.text($firstVariantInContainer.attr('data-variant-name-actual'));
      $texture.removeClass('active');
      $texture.each(function setTextureImageOnOrificeChange() {
        if ($firstVariantInContainer.attr('data-variant-name') === $(this).attr('data-variant-name') && !textureSet) {
          textureSet = true;
          $(this).addClass('active');
        }
      })
    });

    $textureSelect.on('click', function selectTexture() {
      const $this = $(this);
      const variantId = $this.attr('data-variant-id');
      const variantHandle = $this.attr('data-variant-name');
      const variantName = $this.attr('data-variant-name-actual');
      const active = 'active';
      const variantNospace = variantHandle.replace(/-/g, '');

      let variantSet = false;
      let $currentTexture;
      let firstOrifice = false;
      let firstTexture = false;

      $orificeSelect.each(function (index) {
        const $this = $(this);
        if (index === 0 && $this.hasClass('product-orifice-side-view--active')) {
          firstOrifice = true;
        }
      });

      $textureSelect.each(function (index) {
        const $current = $(this);
        if (index === 0 && $current.attr('data-variant-name') === $this.attr('data-variant-name')) {
          firstTexture = true;
        }
      });

      if (firstOrifice && firstTexture) {
        $textureBest.show();
      } else {
        $textureBest.hide();
      }


      setActiveState($this, 'product-texture-side-view--active');
      $textureTitle.text(variantName);
      $purchaseBarVariant.text(variantName);

      $addToCart.attr('data-variant-id', variantId);

      $texture.each(function setTextureImage() {
        if ($(this).attr('data-variant-name') === variantNospace && !variantSet) {
          variantSet = true;
          $currentTexture = $(this);
        }
      });

      $texture.removeClass(active);
      $currentTexture.addClass(active);
      setActiveDescription($this.attr('data-index'));
    });

    $playButton.on('click', function playVideo() {
      const $this = $(this);
      const showingClass = 'showing';
      $this.fadeOut();

      $videoContainer.addClass(showingClass);
      $video[0].play();
    });

    $videoClose.on('click', function closeVideo() {
      $video[0].pause();
      $videoContainer.removeClass('showing');
      $playButton.fadeIn();
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  ProductPornstar.init = init;
})(window.ProductPornstar = window.ProductPornstar || {}, jQuery);
